/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import Image from 'next/image';
import { useLazyQuery } from '@apollo/client';
import playIcon from '../../../public/assets/play-audio.svg';
import audioListIcon from '../../../public/assets/audio-list.svg';
import pdfListIcon from '../../../public/assets/pdf-list.svg';
import DownloadIcon from '../../../public/assets/download-icon.svg';
import Get_Signed_Url_By_ContentId from '../../gql/queries/get-signed-url-by-contentId.gql';

export default function FeatureContentCard({ content, type, handleClick }) {
  const {
    id, name, thumbnail, contentId,
  } = content;
  const [getSignedUrlByContentId] = useLazyQuery(Get_Signed_Url_By_ContentId);

  const handleDownloadClick = async () => {
    try {
      const { data: pdfResponse } = await getSignedUrlByContentId({
        variables: {
          contentId,
          type: 'pdf',
        },
      });
      if (pdfResponse?.getSignedUrlByContentId?.signedUrl) {
        window.open(pdfResponse?.getSignedUrlByContentId?.signedUrl, '_blank');
      }
    } catch (err) {
      console.error('Error fetching handout:', err);
    }
  };

  return (
    <div className="w-full bg-white rounded-[10px] shadow-sm p-4 flex items-center justify-between relative">
      <div className="flex items-start gap-4">
        <Image
          src={thumbnail || (type === 'audio' ? audioListIcon : pdfListIcon)}
          alt={name}
          width={80}
          height={80}
          className="lg:w-32 rounded-md w-[90px] h-full"
        />
        {/* <div className="flex flex-col gap-1"> */}
        <h3 className="text-lg font-semibold md:w-[320px] line-clamp-5">{name}</h3>
        {/* <div className="flex items-center gap-1 text-base lg:mt-3">
            <Image
              src={calender}
              alt="calender-icon"
              width={80}
              height={80}
              className="w-5 h-5"
            />
            <span>{createdTime}</span>
          </div> */}
        {/* </div> */}
      </div>

      {type === 'pdf' && (
        <button type="button" className="flex items-center gap-2 bg-gray-100 px-5 py-2 rounded-full text-gray-700 hover:bg-gray-200 absolute right-4 bottom-4" onClick={handleDownloadClick}>
          <Image
            src={DownloadIcon}
            alt="download-icon"
            width={80}
            height={80}
            className="w-5 h-5"
          />
          <span>Download</span>
        </button>
      )}
      {type === 'audio' && (
      <Image
        src={playIcon}
        alt="play-icon"
        width={80}
        height={80}
        className="lg:w-12 lg:h-12 w-10 h-10 cursor-pointer"
        onClick={() => handleClick({ id })}
      />
      )}
    </div>
  );
}

FeatureContentCard.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    createdTime: PropTypes.string,
    date: PropTypes.string,
    type: PropTypes.oneOf(['pdf', 'audio', 'list']),
    thumbnail: PropTypes.string,
    contentId: PropTypes.string,
  }),
  type: PropTypes.string,
  handleClick: PropTypes.func,
};
